export type SiteState = {
    loading: boolean;
    success: boolean;
    error: boolean;
    siteId: string;
    siteName: string;
    deleteSiteLoading: boolean;
    deleteSiteSuccess: boolean;
    excludedStates: {}
    country: string
    state: string
};

export const initialSite: SiteState = {
    loading: false,
    success: false,
    error: false,
    siteId: '',
    siteName: '',
    deleteSiteLoading: false,
    deleteSiteSuccess: false,
    excludedStates: {},
    country: '',
    state: ''
};
